import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { actions } from '../redux/modules/authentication'
import { actions as userActions } from '../redux/modules/userActions'
import { Form, Icon, Input, Button } from 'antd'
import LoginChoosePassword from './LoginChoosePassword'

const FormItem = Form.Item

const propTypes = {}

class Login extends Component {
  constructor(props) {
    super(props)
    this.state = {
      choosePasswordVisible: false
    }
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.error !== nextProps.error) {
      if (nextProps.error === 'Error: New user') {
        this.setState({
          choosePasswordVisible: true
        })
      }
    }
    if (this.props.userActions !== nextProps.userActions) {
      this.props.login(nextProps.userActions.passwordChange)
    }
  }
  handleSubmit = e => {
    if (e) e.preventDefault()

    const form = this.props.form

    form.validateFields((err, values) => {
      if (err) {
        return
      }

      this.props.login({
        username: values.userName,
        password: values.password
      })
    })
  }

  setPassword = password => {
    const form = this.props.form
    form.validateFields((err, values) => {
      this.props.setInitialPassword({
        username: values.userName,
        password: password
      })
    })
  }

  render() {
    if (this.props.loggedIn) {
      const { from } = this.props.location.state || { from: { pathname: '/dashboard' } }

      return <Redirect to={from} />
    }

    const { getFieldDecorator } = this.props.form

    const error = this.props.error ? (
      <div className="alert alert-danger" data-testid="error">
        {this.props.error}
      </div>
    ) : null

    return (
      <div className="container h-100">
        <div className="row h-100 justify-content-center align-items-center">
          <LoginChoosePassword
            visible={this.state.choosePasswordVisible}
            setPassword={this.setPassword}
          />
          <Form onSubmit={this.handleSubmit} className="login-form" data-testid="form">
            <h1 className="gtech-login-title">GTech Management</h1>
            {error}
            <div className="alert alert-light">Please enter your access credentials</div>
            <FormItem>
              {getFieldDecorator('userName', {
                rules: [{ required: true, message: 'Type in your username' }]
              })(
                <Input
                  prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
                  placeholder="Username"
                  data-testid="userName"
                />
              )}
            </FormItem>
            <FormItem>
              {getFieldDecorator('password', {
                rules: [{ required: true, message: 'Type in your password' }]
              })(
                <Input
                  prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                  type="password"
                  placeholder="Password"
                  data-testid="password"
                />
              )}
            </FormItem>
            <FormItem>
              <Button
                type="primary"
                htmlType="submit"
                className="login-form-button"
                data-testid="submit"
              >
                Log in
              </Button>
            </FormItem>
          </Form>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, { location }) => ({
  location,
  loggedIn: !!state.authentication.user,
  error: state.authentication.error,
  loggingIn: state.authentication.loggingIn,
  userActions: state.userActions
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}, actions, userActions), dispatch)
})

Login.propTypes = propTypes
export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(Login))



// WEBPACK FOOTER //
// ./src/containers/Login.js